import getSliceName from '@om-fe/core/utils/get-slice-name';
import { DisciplinesType } from '@om-fe/models';
import {
    TOP_BETS_SPORT_WITH_LOCATION_PATH,
    TOP_BETS_SPORT_WITH_CATEGORY_PATH,
    TOP_BETS_SPORT_WITH_LOCATION_PATH_AND_TIMEZONE,
    TOP_BETS_SPORT_WITH_CATEGORY_PATH_AND_TIMEZONE,
    TOP_BETS_SPORT_WITH_CHILDREN_PATH,
    TopBetsTopic,
    slicePrefix,
} from './nav.constants';
import getConfig from '@om-fe/core/utils/config';

export function getTopBetSliceName(instanceId: string): string {
    return getSliceName(slicePrefix, instanceId);
}

export function getTopBetsTopic(
    disciplineId: string,
    isCategory?: boolean,
): TopBetsTopic {
    const topicTimezoneOffset: boolean = getConfig().matchListConfig?.topBets?.topicTimezoneOffset ?? false;
    const timezone: number = (new Date()).getTimezoneOffset();
    const timezoneOffset: number = timezone !== 0 ? timezone * -1 : timezone;

    return {
        path: disciplineId === DisciplinesType.ElectronicSports
            ? TOP_BETS_SPORT_WITH_CHILDREN_PATH 
            : (isCategory
                ? topicTimezoneOffset ? TOP_BETS_SPORT_WITH_CATEGORY_PATH_AND_TIMEZONE : TOP_BETS_SPORT_WITH_CATEGORY_PATH
                : topicTimezoneOffset ? TOP_BETS_SPORT_WITH_LOCATION_PATH_AND_TIMEZONE : TOP_BETS_SPORT_WITH_LOCATION_PATH
            ),
        params: {
            disciplineId,
            offsetTime: String(timezoneOffset),
        },
    };
}
